import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=00cd68b0&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=ts&"
export * from "./reset-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd68b0",
  null
  
)

export default component.exports